module.exports = fox._r("images/promo/lang-arr-d.png", __webpack_public_path__ + "_/_/_/common/frame/images/promo/lang-arr-d.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/promo/lang-arr-d.png
// module id = 119
// module chunks = 2